/* Client for the Trimble Feedback Service.
 * https://trimble-feedback.netlify.app/docs/api.md
 *
 * Submissions go to our own /api/feedback route, which forwards them to the
 * service. The service allow-lists browser origins, so posting to it directly
 * from the page fails CORS on localhost and on deploy previews; a same-origin
 * request avoids the preflight entirely. The upstream URL lives server-side in
 * NEXT_PUBLIC_FEEDBACK_URL (see src/app/api/feedback/route.ts).
 */

const FEEDBACK_ENDPOINT = "/api/feedback"

export type FeedbackScore = 1 | 5

/**
 * `email` is sent only when the visitor has an active TID session, so feedback
 * can be followed up on. Note the service's documented body is score/comment/
 * pageUrl only — until it accepts and stores an email, this field is accepted
 * but dropped, and won't appear in the CSV export.
 */
export async function submitFeedback(
  score: FeedbackScore,
  comment?: string,
  email?: string,
): Promise<boolean> {
  try {
    const res = await fetch(FEEDBACK_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        date: new Date().toISOString(),
        score,
        comment: comment?.trim() || undefined,
        pageUrl: window.location.href,
        email: email?.trim() || undefined,
      }),
    })
    return res.ok
  } catch (err) {
    console.error("[feedback] Failed to submit feedback", err)
    return false
  }
}
